import { RuntimeConfig } from './runtime-config.model';

export const LEGACY_RUNTIME_CONFIG_DEFAULTS: RuntimeConfig = {
  environment: {
    target: 'prod'
  },
  backend: {
    baseUrl: 'https://api-monitor.ggtaxi.com/',
    reverseGeocodeUrl: 'https://geocode.ggtaxi.com/api/reverse',
    forwardGeocodeUrl: 'https://geocode.ggtaxi.com/api/suggest'
  },
  realtime: {
    baseUrl: 'https://api-monitor.ggtaxi.com/',
    monitorPath: 'monitor',
    transports: ['websocket']
  },
  maps: {
    googlePlacesApiKey: 'AIzaSyCWHThC5kdn__RjWOEidgKOXpfgChRYMIs',
    googlePlacesScriptUrl: 'https://maps.googleapis.com/maps/api/js',
    tileLayerUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  },
  crm: {
    homeBaseUrl: 'https://crm.team.gg/home',
    guaranteedShuttlesBaseUrl: 'https://crm.team.gg/reports/guaranteed-shuttles'
  },
  assets: {
    airConditioningCsvPath: 'data/airConditioning.csv',
    sounds: {
      newOrder: './sounds/notification.mp3',
      orderCancelled: './sounds/notification5.mp3'
    }
  },
  routing: {
    useHashLocation: false,
    enableLegacyAccessAliases: true,
    enableLegacyAppAliases: true
  }
};
